import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <p class="mb-3 bold text-center">* * * </p>

    <div class="poem">
      <p class="poem-block mb-3">
      Fora montaro, nebula montaro, montaro, <br/>
      Neĝo falanta, la neĝ’ forfluganta, la neĝ’… <br/>
      Eble vi aŭdis, ekzistas ja urb’ mia kara, <br/>
      Sed ne por ĉiuj konvenas de l’ urbo la leĝ’.
      </p>

      <p class="poem-block mb-3">
      Strangaj por ni estas ĝiaj loĝantoj la tutaj: <br/>
      Pensoj, paroloj – nu ĉio en neordinar’. <br/>
      Konversacioj ĉe ili tuj iĝas diskutoj, <br/>
      Kaj ne ekzistas la solvo de la problemar’.
      </p>

      <p class="poem-block mb-3">
      En la malĝoj’ ili ridas, anstataŭ ol plori, <br/>
      En la gajec’ trinkas vinon bonegan kun gust’. <br/>
      Ĉarmajn virinojn scipovas l’ urbanoj adori, <br/>
      Sed al komfort’ ili kraĉas, kaj kraĉas laŭ just’.
      </p>

      <p class="poem-block mb-3">
      Estas ĉielo por ili anstataŭ tegmento. <br/>
      Manoj amataj protektas de pluvo kaj vent’. <br/>
      Min ne forlasas amara kaj stranga la sento, <br/>
      Ke mi ĉi-urbon jam perdis en iu moment’.
      </p>

      <p class="poem-block mb-3">
      Iam trairis mi tutan la urbon sencele, <br/>
      Spektis, sed vidis nenion per rekta rigard’. <br/>
      Vante babilis mi, ridis kaj paŝis ŝancele, <br/>
      Kaj preterlasis la urbon en stulta hazard’.
      </p>

      <p class="poem-block mb-3">
      Nun mi esperas, mi strebas, mi estas serĉanta, <br/>
      Tamen la vojon perfide forviŝis memor’. <br/>
      Trajno ne taŭgas, ne taŭgas la tramo kaj aŭto, <br/>
      L’ urbon perditan nur serĉas dolore la kor’.
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Jurij Kukin'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['FYqCC1pzvks'],
    itemTranslator: translator.esp
  }
}

export default item;